<template>
  <div class="">
    <div class="flex mb-2" @click="changePage('index')">
      <span class="font-semibold uppercase text-gray-600"><i class="material-icons mr-2">arrow_back</i></span><strong class="pb-4 uppercase text-gray-600">Back</strong>
    </div>
    <form @submit.prevent="edit">
      <div class="flex pt-4 border-t">
        <div class="w-1/3">
          <h3 class="font-semibold uppercase text-gray-600 text-xl">
            Edit Account
          </h3>
          <p class="text-gray-600">{{ id }}</p>
        </div>
        <div class="w-2/3">
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">First Name</span>
              <input
                v-model="account.firstName"
                class="form-input block w-full"
                placeholder="Abbay"
              />
            </label>
            <label class="block w-1/2">
              <span class="text-gray-700">
                Last Name
              </span>
              <input
                v-model="account.lastName"
                class="form-input block w-full"
                placeholder="Kassa"
              />
            </label>
          </div>
          <div class="flex space-x-4 mt-4">
            <label class="block w-1/2">
              <span class="text-gray-700">
                Email
              </span>
              <input
                v-model="account.email"
                class="form-input block w-full"
                type="email"
                placeholder="contact@sheraton.com"
              />
            </label>
          </div>
          <div class="mt-4">
            <button
              :disabled="busy"
              class="w-32 py-2 text-ilift-900 rounded shadow"
              :class="
                busy
                  ? 'bg-ilift-200 cursor-not-allowed'
                  : 'bg-ilift-500 hover:bg-ilift-600'
              "
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  props: ['account', 'changePage'],
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    id() {
      return this.account ? this.account._id : "";
    },
  },
  created() {
  },
  methods: {
    edit() {
      this.busy = true;
      this.$http
        .patch(`accounts/${this.id}`, this.account)
        .then(() => {
          window.flash({
            body: "Account updated successfully!",
            type: "success",
          });
          this.changePage('index');
        })
        .catch(err => {
          window.flash({ body: "Failed to edit account!", type: "error" });
          console.log(err);
        })
        .finally(() => (this.busy = false));
    },
  },
};
</script>
